import { useI18N } from "@src/language/language-context";
import { ActiveInstallationProcessPayload } from "@src/types/ota-update";

export const useOtaBackupProcessInProgressModal = (
  activeInstallationData: ActiveInstallationProcessPayload,
) => {
  const i18n = useI18N();

  const operationId =
    activeInstallationData?.update_details?.sftp_push_operation_id;
  const hasOperationId = Boolean(String(operationId ?? "").trim());

  const targetPath =
    activeInstallationData?.target_path ||
    i18n("modules.otaBackupProcessInProgressModal.targetPathFallback");

  const texts = {
    title: i18n("modules.otaBackupProcessInProgressModal.title"),
    backupDetailsTemplate: i18n(
      "modules.otaBackupProcessInProgressModal.backupDetailsTemplate",
    ),
    firstStepText: i18n(
      "modules.otaBackupProcessInProgressModal.waitingBulletPointSecureConnection",
    ),
    secondStepText: i18n(
      "modules.otaBackupProcessInProgressModal.waitingBulletPointCreateBackup",
    ),
    thirdStepText: i18n(
      "modules.otaBackupProcessInProgressModal.waitingBulletPointUploadBackup",
    ),
    pushInBackgroundButtonText: i18n(
      "modules.otaBackupProcessInProgressModal.pushInBackgroundButtonText",
    ),
  };

  const installationProgressSteps = [
    texts.firstStepText,
    texts.secondStepText.replace("{targetPath}", targetPath),
    texts.thirdStepText,
  ];

  const folders =
    activeInstallationData?.update_details?.folder_structure_result?.entries?.map(
      (entry) => entry?.path,
    ) ||
    activeInstallationData?.archive_structure_root_level ||
    [];

  return {
    texts,
    backupDetails: hasOperationId
      ? texts.backupDetailsTemplate.replace(
          "{operationId}",
          String(operationId),
        )
      : "",
    folders,
    installationProgressSteps,
  };
};
